export default "__VITE_ASSET__CKB__U7J__"